{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Farbwähler",
  "twoDimensionalSlider": "2D-Schieberegler",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
